import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var _ref = {
  name: "1vc44gm",
  styles: "height:100%;gap:24px;"
};
var _ref2 = {
  name: "1po3p4o",
  styles: "gap:16px;"
};
var _ref3 = {
  name: "1fmaocf",
  styles: "gap:32px;"
};
export var agencyCard = appearance => /*#__PURE__*/css("display:flex;flex-direction:", appearance === 'vertical' ? 'column' : 'row', ";justify-content:space-between;align-items:flex-start;position:relative;padding:16px;background:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:8px;margin-bottom:", appearance === 'vertical' ? 0 : '12px', ";", appearance === 'vertical' && _ref, " ", appearance === 'horizontal' && _ref2, " ", appearance === 'tablet' && _ref3);
var _ref4 = {
  name: "14ldegz",
  styles: "padding-right:24px;"
};
export var profile = appearance => /*#__PURE__*/css("display:flex;flex-direction:", appearance === 'horizontal' ? 'row' : 'column', ";justify-content:space-between;", appearance === 'tablet' && _ref4);
var _ref5 = {
  name: "1h94ces",
  styles: "max-width:192px;margin-left:16px;"
};
var _ref6 = {
  name: "1u8pvn2",
  styles: "padding-bottom:12px;"
};
export var nameDetail = appearance => /*#__PURE__*/css("margin-top:", appearance === 'vertical' ? '16px' : '0', ";", appearance === 'horizontal' && _ref5, " ", appearance === 'vertical' && _ref6);
var _ref7 = {
  name: "1afadug",
  styles: "display:flex;flex-direction:column;gap:14px;max-width:122px;"
};
var _ref8 = {
  name: "1200jbv",
  styles: "height:42px;"
};
export var imageContainer = appearance => /*#__PURE__*/css(appearance === 'horizontal' && _ref7, " ", appearance === 'vertical' && _ref8);
var _ref9 = {
  name: "1r0iyn3",
  styles: "width:fit-content;height:32px;max-height:32px;"
};
export var image = appearance => /*#__PURE__*/css("width:122px;height:fit-content;max-height:64px;", appearance === 'tablet' && _ref9);
export var address = /*#__PURE__*/css(designTokenFonts.mini);